export interface Selection {
    start: number;
    end: number;
}

export interface ValueWithSelection {
    value: string;
    selection: Selection;
}

export enum Direction {
    Backward,
    Forward,
}

export default abstract class Mask {
    constructor() {
        if (new.target === Mask) {
            throw new TypeError('Cannot construct abstract class Mask instance directly');
        }
    }

    abstract conforms(value: string): boolean;
    abstract input(vs: ValueWithSelection, char: string): ValueWithSelection;
    abstract remove(vs: ValueWithSelection, direction: Direction): ValueWithSelection;
    // NOTE: Consider rewriting unmask return type to UnmaskedValueWithSelection
    abstract unmask(vs: ValueWithSelection): ValueWithSelection;
    getValueWithPlaceholder(_: ValueWithSelection): string {
        return '';
    }
}
